<div class="dialog-main">
    <div class="dialog">
        <div class="mat-dialog-actions" mat-dialog-actions [align]="selectedAlign" (click)="close()">
            <button mat-button mat-dialog-close><mat-icon>close</mat-icon></button>
        </div>
        <div class="text">
            <h3>{{ dialogconfiguration.targetData }}{{ 'email.resendNewsLetter' | translate }}</h3>
        </div>
        <div class="back-and-to-buttons">
            <button (click)="sendToNewSubscribers()">{{ 'email.toNewSubscribers' | translate }}</button>
            <button (click)="sendToAllSubscribers()">{{ 'email.toAllSubscribers' | translate }}</button>
        </div>
    </div>
</div>